import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["width"],
  _excluded2 = ["width"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
// This styling has been specifically added for the th to ensure that there is no left
// padding which will occur by default. These rely on attribute selectors matching the
// "row" scope value or any colspan value so only come into effect in specific instances
// and override the default styling provided by the CSS reset
var theadStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&[scope="row"]': {
    paddingLeft: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&[colspan]': {
    paddingLeft: 0
  }
});

// These are the names of the HTML element relating to table composition that are considered
// acceptable values to pass to the 'as' property of the RenderHtml function. This list should
// be comprehensive.

// Creating a union of all the different table element properties allows the RenderHtml type to be more concise

// This is the type for the function that is commonly used by the components render a UI Kit component.

// This is the common function used by all the components. Behaviour is differentiated through the value
// passed as the 'as' prop. Not all components allow styling, but the structure of this function allow us
// to iteratively add styling capabilities in the future.
var renderHtml = function renderHtml(_ref) {
  var _forgeDoc$children;
  var NativeHtmlComponent = _ref.as,
    forgeDoc = _ref.forgeDoc,
    render = _ref.render,
    props = _ref.props,
    style = _ref.style,
    css = _ref.css;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    jsx(NativeHtmlComponent, _extends({}, props, {
      style: style,
      css: css
    }), (_forgeDoc$children = forgeDoc.children) === null || _forgeDoc$children === void 0 ? void 0 : _forgeDoc$children.map(render))
  );
};

// The next section defines all the components for table composition...
// The main differences between each are:
// - the value passed to the "as" prop as this will determine the HTML element ultimately rendered on the page.
// - the casting of the received ForgeDoc props
// - whether or not styles are passed
//
// Styling is only applied to table and th and currently only supports "width"
// We may choose to iteratively add more styles as necessary to any of the tabular components.
var TableRoot = function TableRoot(_ref2) {
  var forgeDoc = _ref2.forgeDoc,
    render = _ref2.render;
  var _ref3 = forgeDoc.props,
    width = _ref3.width,
    props = _objectWithoutProperties(_ref3, _excluded);
  return renderHtml({
    as: 'table',
    forgeDoc: forgeDoc,
    render: render,
    props: props,
    style: {
      width: width
    }
  });
};
var TableCaption = function TableCaption(_ref4) {
  var forgeDoc = _ref4.forgeDoc,
    render = _ref4.render;
  var _ref5 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return renderHtml({
    as: 'caption',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableHead = function TableHead(_ref6) {
  var forgeDoc = _ref6.forgeDoc,
    render = _ref6.render;
  var _ref7 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref7), _ref7));
  return renderHtml({
    as: 'thead',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableBody = function TableBody(_ref8) {
  var forgeDoc = _ref8.forgeDoc,
    render = _ref8.render;
  var _ref9 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref9), _ref9));
  return renderHtml({
    as: 'tbody',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableFoot = function TableFoot(_ref10) {
  var forgeDoc = _ref10.forgeDoc,
    render = _ref10.render;
  var _ref11 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref11), _ref11));
  return renderHtml({
    as: 'tfoot',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableRow = function TableRow(_ref12) {
  var forgeDoc = _ref12.forgeDoc,
    render = _ref12.render;
  var _ref13 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref13), _ref13));
  return renderHtml({
    as: 'tr',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableCell = function TableCell(_ref14) {
  var forgeDoc = _ref14.forgeDoc,
    render = _ref14.render;
  var _ref15 = forgeDoc.props,
    props = _extends({}, (_objectDestructuringEmpty(_ref15), _ref15));
  return renderHtml({
    as: 'td',
    forgeDoc: forgeDoc,
    render: render,
    props: props
  });
};
var TableHeadCell = function TableHeadCell(_ref16) {
  var forgeDoc = _ref16.forgeDoc,
    render = _ref16.render;
  var _ref17 = forgeDoc.props,
    width = _ref17.width,
    props = _objectWithoutProperties(_ref17, _excluded2);
  return renderHtml({
    as: 'th',
    forgeDoc: forgeDoc,
    render: render,
    props: props,
    style: {
      width: width
    },
    css: theadStyles
  });
};
export { TableRoot, TableCaption, TableHead, TableBody, TableFoot, TableRow, TableCell, TableHeadCell };